<!-- 目录配置 -->
<template>
  <div class="progress-category" style="margin-top: 14px">
    <v-card class="elevation-0" style="width: 100%; overflow: hidden">
      <div class="pt-4 px-3">
        <v-btn
          color="#00bea9"
          depressed
          dark
          small
          height="30"
          style="padding: 0 8px"
          min-width="30"
          class="ml-2 mb-3"
          @click="(dialog.data = { companyIds: [] }), (dialog.show = true)"
        >
          <v-icon size="16">mdi-plus</v-icon>新增目录
        </v-btn>
      </div>

      <v-data-table
        :headers="headers"
        :items="list"
        :items-per-page="search.pageSize"
        class="flex-1 pb-5 max-width header-grey px-4"
        hide-default-footer
        item-key="id"
        no-data-text="暂无查询数据"
        :loading="listLoading"
      >
        <template v-slot:item.status="{ item }">
          <v-icon v-if="item.status == 0" color="primary" size="12" class="mr-3">可用</v-icon>
          <v-icon v-else color="error" size="12" class="mr-3">禁用</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="flex-y-center">
            <v-icon
              color="primary"
              size="12"
              title="删除"
              class="mr-3"
              @click="$emit('config', item.id)"
            >配置</v-icon>
            <v-icon
              color="primary"
              size="12"
              title="删除"
              class="mr-3"
              @click="handleUpdate(item)"
            >修改</v-icon>
            <v-icon
              v-if="item.status == 1"
              color="primary"
              size="12"
              title="删除"
              class="mr-3"
              @click="updateStatus(item, 0)"
            >恢复</v-icon>
            <v-icon
              v-else
              color="error"
              size="12"
              title="删除"
              class="mr-3"
              @click="updateStatus(item, 1)"
            >禁用</v-icon>
            <v-icon
              color="error"
              size="12"
              title="删除"
              class="mr-3"
              @click="handleDelete(item.id)"
            >删除</v-icon>
          </div>
        </template>
      </v-data-table>
      <div class="flex-justify-end">
        <pagination
          v-model="search.pageNo"
          :size="search.pageSize"
          :total="total"
          @input="getList"
          @changePageSize="changePageSize"
        />
      </div>
    </v-card>

    <re-dialog
      :value.sync="dialog.show"
      :title="`新增目录`"
      @ok="handleConfirm"
    >
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>进度目录名称：
        </div>
        <form-item
          v-model="dialog.data.progressName"
          class="mr-0"
          placeholder="请输入进度目录名称"
          required
          type="text"
        />
      </div>
      <div class="dialog-form-item">
        <div class="dialog-form-item__label">
          <span class="red--text ml-1">*</span>适用公司：
        </div>
        <form-item
          v-model="dialog.data.companyIds"
          class="mr-0"
          placeholder="所属公司"
          type="select"
          required
          multiple
          :options="companyList"
        />
      </div>
    </re-dialog>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      headers: [
        {
          text: '进度目录名称',
          value: 'progressName',
          width: '260',
          sortable: false,
        },
        { text: '适用公司', value: 'companyName', width: 500 },
        { text: '状态', value: 'status', width: 100, sortable: false },
        {
          text: '操作',
          value: 'action',
          width: 200,
          sortable: false,
          fixed: 'end',
        },
      ],
      list: [],
      search: {
        pageSize: 10,
        pageNo: 1,
        data: {},
      },
      total: 0,
      listLoading: false,
      dialog: {
        // 添加 编辑 阶段弹框
        show: false,
        data: {
          progressName: '',
          id: null,
          companyIds: [],
        },
      },
      companyList: [],
    };
  },
  watch: {
    type() {
      this.initLoad();
    },
  },
  mounted() {
    this.initLoad();
    this.$http.get(this.$api.getAllCompanyList, {}).then((res) => {
      this.companyList = Object.keys(res.result).map((key) => {
        return { value: Number(key), text: res.result[key] };
      });
    });
  },
  methods: {
    initLoad() {
      this.search.pageNo = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      this.$http
        .get(this.$api.progressCategoryList, {
          data: {
            pageNo: this.search.pageNo,
            pageSize: this.search.pageSize,
            type: this.type,
          },
        })
        .then((res) => {
          this.list = res.result.records || [];
          this.total = res.result.total || 0;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleUpdate(item) {
      this.dialog.data.progressName = item.progressName;
      this.dialog.data.id = item.id;
      this.dialog.data.companyIds = item.companyId
        ? item.companyId.split(',').map((el) => Number(el))
        : [];
      this.dialog.show = true;
    },
    changePageSize(e) {
      this.search.pageSize = e;
      this.initLoad();
    },
    updateStatus(item, status) {
      this.$http
        .put(this.$api.progressCategoryUpdateStatus, {
          data: { id: item.id, status },
        })
        .then(() => {
          this.getList();
          this.$message.success('操作成功');
        });
    },
    handleDelete(id) {
      this.$confirm({ text: '是否确认删除改目录？' }).then((vm) => {
        vm.loading = true;
        this.$http
          .delete(this.$api.progressCategoryDelete, {
            data: { id },
          })
          .then((res) => {
            this.$message.success(res.message);
            this.getList();
          })
          .finally(() => {
            vm.show = false;
            vm.loading = false;
          });
      });
    },
    handleConfirm() {
      const apiUrl = this.dialog.data.id
        ? this.$api.progressCategoryUpdate
        : this.$api.progressCategoryAdd;
      const method = this.dialog.data.id ? 'put' : 'post';
      this.$http[method](apiUrl, {
        data: { ...this.dialog.data, type: this.type },
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('操作成功');
          this.dialog.show = false;
          this.dialog.data.id ? this.getList() : this.initLoad();
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &__label {
    width: 120px;
    flex-shrink: 0;
    text-align: right;
  }
}
</style>
